import { render, staticRenderFns } from "./BusinessPaymentCreate.vue?vue&type=template&id=6d9c3838&scoped=true&"
import script from "./BusinessPaymentCreate.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentCreate.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPaymentCreate.vue?vue&type=style&index=0&id=6d9c3838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c3838",
  null
  
)

export default component.exports